import { ApiException } from './api.exception';
import { ErrorsPipe } from '@app-pipes/error-code.pipe';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from '@app-components/common/error-dialog/error-dialog.component';
import { Injectable, Injector, inject } from '@angular/core';
import { GlobalErrorHandler } from './error-handler.service';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MatchError {
  private readonly injector = inject(Injector);
  pipeErrors = new ErrorsPipe();
  constructor(
    public dialog: MatDialog,
    private globalErrorHandler: GlobalErrorHandler
  ) {}

  public errorHandler(error: any): void {
    const errors = [403];

    if (errors.includes(error.Status)) return;

    if (!error.Code) {
      this.openTranslatedErrorDialog(
        error?.Description || 'somethingWentWrongErrorSubtitle',
        error
      );
    } else {
      const description =
        this.pipeErrors.transform(error.Code) ||
        `Error code: ${error.Code}: ${error?.Description || 'something went wrong'}`;
      this.openTranslatedErrorDialog(description, error);
    }
  }

  public logError(e: any): void {
    if (e instanceof ApiException) {
      if (e.Status === 500) {
        this.globalErrorHandler.handleError(e);
      }
    } else {
      this.globalErrorHandler.handleError(e);
    }
  }

  public openErrorDialog(
    title: string,
    description: string,
    value?: number
  ): void {
    this.dialog.open(ErrorDialogComponent, {
      width: '400px',
      data: { title, description, value },
      autoFocus: false,
    });
  }

  private openTranslatedErrorDialog(description: string, error: any): void {
    const translate = this.injector.get(TranslateService);
    const validationDetails = this.getValidationDetailsSuffix(error);
    let translatedDescription = description;

    translate
      .stream(description || ' ')
      .pipe(take(1))
      .subscribe((res: string) => {
        translatedDescription = res;
        const finalDescription = validationDetails
          ? `${translatedDescription}. ${validationDetails}`
          : translatedDescription;
        this.openErrorDialog('error', finalDescription);
      });
  }

  private getValidationDetailsSuffix(error: any): string {
    if (!(error instanceof ApiException) || error.Errors.length === 0) {
      return '';
    }

    const seen = new Set<string>();
    const messages: string[] = [];

    for (const err of error.Errors) {
      const line = err.errorMessage?.trim();
      if (!line) {
        continue;
      }

      const key = `${err.propertyName ?? ''}:${line}`;
      if (seen.has(key)) {
        continue;
      }

      seen.add(key);
      messages.push(line);
    }

    return messages.join('. ');
  }
}
